import { useMemo } from 'react'
import type { Event, Group, GroupEvent, GroupEventRequest } from '../../types'
import type { VisibleRequest } from './PendingRequestsSection'

/**
 * The pending suggestions worth showing: not already linked (an admin may have
 * linked it directly), still from a member, and for an event that resolved.
 */
export function useVisibleRequests(
  group: Group | null | undefined,
  groupEvents: GroupEvent[],
  requests: GroupEventRequest[],
  events: Event[],
): VisibleRequest[] {
  return useMemo(() => {
    if (!group) return []
    const linked = new Set(groupEvents.map(ge => ge.eventId))
    const byId = new Map(events.map(e => [e.id, e]))
    return requests.flatMap(request => {
      const event = byId.get(request.eventId)
      return event && !linked.has(request.eventId) && group.memberIds.includes(request.requestedBy)
        ? [{ request, event }]
        : []
    })
  }, [group, groupEvents, requests, events])
}
